export default {
  sections: {
    alcohol_percentage: 'Conținut de alcool: {{value}}%',
    price_per_unit: 'Preț per {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ingrediente',
    allergens: 'Alergeni',
    additives: 'Aditivi',
    nutrition_breakdown: {
      title: 'Informații nutriționale',
      description: '100 {{unit}} conține:',
      items: {
        energy: 'Energie',
        fat: 'Grăsimi',
        saturates: 'din care acizi grași saturați',
        carbohydrates: 'Carbohidrați',
        sugars: 'din care zaharuri',
        protein: 'Proteine',
        salt: 'Sare',
      },
    },
  },
  units: {
    l: 'litru',
    kg: 'kilo',
    default: 'unitate',
  },
};
